import React from "react";
import Footer from "../components/Shared/Footer";
import Breadcrumbs from "../components/Article_Display_Page/Breadcrumbs";
import Navbar from "../components/NavBar/Navbar";
import Typography from "@mui/material/Typography";
import ShareButton from "../components/Article_Display_Page/ShareButton";
import { Grid } from "@mui/material";
import { styled } from "@mui/system";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material/styles";
import useGetSiteImage from "../hooks/useGetSiteImage";

const GridContainerMain = styled("div")({
  padding: "0 25% 5px 25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  "& img": {
    maxWidth: "100%",
    height: "auto",
  },
  "@media (max-width: 1600px)": {
    paddingLeft: "20%",
    paddingRight: "20%",
  },
  "@media (max-width: 960px)": {
    paddingLeft: "10%",
    paddingRight: "10%",
  },
  "@media (max-width: 600px)": {
    paddingLeft: "10%",
    paddingRight: "7%",
  },
});

const IframeStyled = styled("iframe")({
  width: "100%",
  paddingBottom: "1%",
  height: "700px",
  border: 0,
  borderRadius: "1px",
  marginTop: "20px",
  paddingLeft: "25%",
  paddingRight: "25%",
  "@media (max-width: 1600px)": {
    paddingLeft: "20%",
    paddingRight: "20%",
  },
  "@media (max-width: 960px)": {
    paddingLeft: "1%",
    paddingRight: "1%",
  },
  "@media (max-width: 600px)": {
    paddingLeft: "1%",
    paddingRight: "1%",
  },
});

const LogoImage = styled("img")({
  width: "30px",
  height: "30px",
  marginTop: "10px",
});

const LogoContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

const Location = () => {
  const theme = useTheme();
  const altLogo = "AltLogo.png";
  const { imageURL, error } = useGetSiteImage(altLogo);

  return (
    <div style={{backgroundColor: theme.palette.common.background}}>
      <Navbar />
      <Breadcrumbs title={"Lokalizacja"} />
      <Grid container>
        <GridContainerMain>
          <Grid item xs={12} sm={12} md={12}>
            <Typography variant="h1" sx={{ padding: "30px 0 30px 0" }}>
            Zielona Chatka
            </Typography>

            <LogoContainer>
              <LogoImage
                src={!error ? imageURL : ""}
                alt="Logo"
              />
              <Typography
                variant="subtitle1"
                sx={{ paddingLeft: "17px", flex: 1, fontSize: ".8rem" }}
              >
                {" "}
                Kotelnica, 34-406 Białka Tatrzańska, Poland
              </Typography>
              <ShareButton />
            </LogoContainer>

            <Divider sx={{ padding: "5px" }} />
          </Grid>
          </GridContainerMain>
            <Grid container>
              <IframeStyled
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8735.453587045775!2d20.080413639523183!3d49.38874559535671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4715f0ed0509ec21%3A0x21ec2b2519cbbcbd!2sZielona%20Chatka!5e0!3m2!1spl!2sus!4v1735975180134!5m2!1spl!2sus"
                allowFullScreen="true"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></IframeStyled>

          </Grid>
      </Grid>

      <Footer />
    </div>
  );
};

export default Location;